export default "/images/rerun-application.png?e9e93150b715bb5fe6cbcd541ac8756d";